import React from 'react'
import Select from 'react-select'

function FinanceDetails({
  financePartners = [],
  financePartnersError = '',
  selectedFinancePartnerId = null,
  onFinancePartnerClick,
  downPaymentValue = '',
  emiTenureValue = '',
  processingFeesValue = '',
  interestRateValue = '',
  emiAmountValue = '',
  onDownPaymentChange,
  onEmiTenureChange,
  onProcessingFeesChange,
  onInterestRateChange,
  onEmiAmountChange,
  interestRateOptions = [],
  interestRateLoading = false,
  selectedInterestRate = null,
  onCalculateEmi,
  loanSummaryError = '',
  downPaymentLabel = 'Down Payment',
  emiTenureLabel = 'EMI Tenure (Months)',
  processingFeesLabel = 'Processing Fees',
  interestRateLabel = 'Interest Rate (% p.a.)',
  emiAmountLabel = 'EMI Amount',
  disabled = false
}) {
  return (
    <div className="border rounded p-3 mb-3">
      <h6 className="mb-3">Finance Details</h6>
      <div className="row">
        <div className="col-lg-12 col-sm-6 col-12 mb-3">
          {financePartners.length > 0 ? (
            financePartners.map((partner) => {
              const key = partner.FinancePartnerId ?? partner.FinancePartnerName
              const isSelected = selectedFinancePartnerId === key
              return (
                <span
                  key={key}
                  role="button"
                  className={`badge ${isSelected ? 'bg-outline-secondary' : 'bg-soft-secondary'} m-1`}
                  style={{ fontSize: '12px', userSelect: 'none', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}
                  onClick={() => {
                    if (!disabled) {
                      onFinancePartnerClick?.(partner)
                    }
                  }}
                >
                  {partner.FinancePartnerName || ''}
                </span>
              )
            })
          ) : (
            <span className="text-muted small">No finance partners found.</span>
          )}
          {financePartnersError && (
            <div className="text-danger small mt-1">{financePartnersError}</div>
          )}
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">{downPaymentLabel}</label>
          <input
            type="text"
            className="form-control"
            name="DownPayment"
            value={downPaymentValue}
            onChange={onDownPaymentChange}
            disabled={disabled}
          />
        </div>
        <div className="col-lg-2 col-sm-6 col-12 mb-3">
          <label className="form-label">{emiTenureLabel}</label>
          <input
            type="text"
            className="form-control"
            name="EMITenure"
            value={emiTenureValue}
            onChange={onEmiTenureChange}
            disabled={disabled}
          />
        </div>
        <div className="col-lg-2 col-sm-6 col-12 mb-3">
          <label className="form-label">{processingFeesLabel}</label>
          <input
            type="text"
            className="form-control"
            name="ProcessingFees"
            value={processingFeesValue}
            onChange={onProcessingFeesChange}
            disabled={disabled}
          />
        </div>
        <div className="col-lg-2 col-sm-6 col-12 mb-3">
          <label className="form-label">{interestRateLabel}</label>
          <Select
            classNamePrefix="react-select"
            options={interestRateOptions}
            isLoading={interestRateLoading}
            isClearable
            placeholder="Select interest rate"
            value={selectedInterestRate}
            onChange={onInterestRateChange}
            isDisabled={disabled}
          />
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <label className="form-label">{emiAmountLabel}</label>
          <input
            type="text"
            className="form-control"
            name="EMIAmount"
            value={emiAmountValue}
            onChange={onEmiAmountChange}
            disabled={disabled}
          />
        </div>
        <div className="col-lg-12 col-sm-6 col-12 mb-3 d-flex flex-column justify-content-end align-items-end">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={onCalculateEmi}
            disabled={disabled}
          >
            Calculate EMI
          </button>
          {loanSummaryError && (
            <div className="text-danger small mt-2">{loanSummaryError}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default FinanceDetails
